<div *ngIf="{appointment: appointment$ |async, appointmentDropdowns: appointmentDropdowns$ | async} as data;">
  <div *ngIf="data.appointment && data.appointmentDropdowns && currentEmployee && appointmentForm; else loading"
    [@enterAnimation]>
    <form id="appointmentForm" id="appointmentForm" [formGroup]="appointmentForm" fxLayout="column"
      fxLayoutAlign="start center">
      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
          <mat-form-field appearance="fill">
            <mat-label>Date</mat-label>
            <input [matDatepicker]="appointmentPicker" id="dateTime" matInput formControlName="dateTime"
              [max]="maxDate">
            <mat-error *ngIf="appointmentForm.get('dateTime').errors">
              {{appointmentForm.get('dateTime').errors | inputError}}
            </mat-error>
            <mat-datepicker-toggle matSuffix [for]="appointmentPicker"></mat-datepicker-toggle>
            <mat-datepicker #appointmentPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
          <mat-form-field appearance="fill">
            <mat-label>Drop Off</mat-label>
            <input id="appointmentTime" type="time" matInput formControlName="appointmentTime" (ngModelChange)="mapDateTimes('dateTime',
            $event)">
          </mat-form-field>
        </div>
        <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
          <mat-form-field appearance="fill">
            <mat-label>Service Code</mat-label>
            <mat-select (selectionChange)="serviceCodeSelected($event.value,data.appointmentDropdowns.serviceCodes)"
              formControlName="serviceCode">
              <mat-option *ngFor="let sc of data.appointmentDropdowns.serviceCodes" [value]="sc.serviceCode">
                {{sc.serviceCode}} - {{sc.description}}
              </mat-option>
              <mat-select-trigger>
                {{appointmentForm.get('serviceCode').value}}
              </mat-select-trigger>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
          <mat-form-field appearance="fill">
            <mat-label>Priority</mat-label>
            <input id="priorityNumber" matInput type="number" formControlName="priorityNumber"
              [value]="defaultPriorityNumber" (keypress)="validateNumber($event)">
            <mat-error *ngIf="appointmentForm.get('priorityNumber').errors">
              {{appointmentForm.get('priorityNumber').errors | inputError}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
          <mat-form-field appearance="fill">
            <mat-label>WO Default Group</mat-label>
            <mat-select
              (selectionChange)="techOrGroupSelected($event,data.appointmentDropdowns.technicians,data.appointmentDropdowns.technicianGroups)"
              formControlName="techOrTechGroup">
              <mat-optgroup>
                <label fxFlex class="w-full">
                  Tech Groups
                </label>
                <mat-option
                  *ngFor="let tg of data.appointmentDropdowns.technicianGroups | filterBy: ['rooftopId']: currentEmployee.rooftopId | orderBy: 'description'"
                  [value]="tg.id">
                  {{tg.description}}
                </mat-option>
              </mat-optgroup>
              <mat-optgroup>
                <label fxFlex class="w-full">
                  Technicians
                </label>
                <mat-option
                  *ngFor="let tg of data.appointmentDropdowns.technicians | filterBy: ['rooftopId']: currentEmployee.rooftopId | sortNamesBy: ['lastName']"
                  [value]="tg.associateId">
                  {{tg.embedded.associate.lastName}}, {{tg.embedded.associate.firstName}}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
          <mat-form-field appearance="fill">
            <mat-label>Odometer</mat-label>
            <input id="odometerIn" type="number" matInput formControlName="odometerIn"
              (keypress)="validateNumber($event)">
            <mat-error *ngIf="appointmentForm.get('odometerIn').errors">
              {{appointmentForm.get('odometerIn').errors | inputError}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
          <mat-form-field appearance="fill">
            <mat-label>Service Advisor</mat-label>
            <mat-select formControlName="serviceAdvisorId">
              <mat-option
                *ngFor="let advisor of data.appointmentDropdowns.serviceAdvisors | filterBy: ['rooftopId']: data.appointment.rooftopId | sortNamesBy: ['lastName']"
                [value]="advisor.embedded.associate.id">
                {{advisor.embedded.associate.lastName ? advisor.embedded.associate.lastName + ', ' : ''}}
                {{advisor.embedded.associate.firstName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
          <mat-form-field appearance="fill">
            <mat-label>Booking Employee</mat-label>
            <mat-select formControlName="employeeId">
              <mat-option
                *ngFor="let advisor of data.appointmentDropdowns.employees | filterBy: ['rooftopId']: data.appointment.rooftopId | sortNamesBy: ['lastName']"
                [value]="advisor.embedded.associate.id">
                {{advisor.embedded.associate.lastName ? advisor.embedded.associate.lastName + ', ' : ''}}
                {{advisor.embedded.associate.firstName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
          <mat-form-field appearance="fill">
            <mat-label>Promised Time</mat-label>
            <input id="promisedDateTime" type="time" matInput formControlName="promisedTime"
              (ngModelChange)="mapDateTimes('promisedDateTime', $event)">
          </mat-form-field>
        </div>

        <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
          <mat-form-field appearance="fill">
            <mat-label>Transport Option</mat-label>
            <mat-select
              (selectionChange)="transportOptionSelected($event.value,data.appointmentDropdowns.transportOptions)"
              formControlName="transportOptionId">
              <mat-option *ngFor="let transportOption of data.appointmentDropdowns.transportOptions"
                [value]="transportOption.id">
                {{transportOption.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="cadillacConcierge" fxFlexFill fxLayout="column" fxLayoutAlign="start center">
        <div fxFlexFill>
          <h3 class="font-medium">Transportation Details</h3>
        </div>
        <div fxFlexFill fxLayout="row wrap" fxLayoutAlign="start center">
          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Pickup Location</mat-label>
              <input id="cadillacConciergePickup" matInput formControlName="cadillacConciergePickup">
            </mat-form-field>
          </div>
          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Dropoff Location</mat-label>
              <input id="cadillacConciergeDropoff" matInput formControlName="cadillacConciergeDropoff">
            </mat-form-field>
          </div>
          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-checkbox id="cadillacConciergeUsePickupLocation" matInput
              formControlName="cadillacConciergeUsePickupLocation">Same as pickup</mat-checkbox>
          </div>
          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Contact Number</mat-label>
              <input id="cadillacConciergeContactPhone" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
                formControlName="cadillacConciergeContactPhone">
            </mat-form-field>
          </div>
        </div>
      </div>
      <mat-slide-toggle fxFlexAlign="start" matInput labelPosition="before" formControlName="communicatorExcludeFrom">
        Exclude from
        Communicator
        Messaging
      </mat-slide-toggle>
    </form>
  </div>
  <ng-template #loading>
  </ng-template>
</div>